import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import { useMemoizedFn } from 'ahooks';
import { Layout, Button } from 'tea-component';
import RoutePrompt from '@gp/components/RoutePrompt';
import ReportSubmitButton from '../ReportSubmitButton';
import { BoolFlag } from '@gp/enums/common';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IReportPageProps extends IBaseProps {
  // 是否为编辑dps周报
  isEdit?: boolean;
  // 是否启用页面离开路由守卫
  isGuide?: boolean;
  // 是否展示周报模块
  isShowReportForm?: boolean;
  isSubmitting?: boolean;
  submitType?: BoolFlag;
  title: string | React.ReactElement | null;
  topbar?: React.ReactElement | null;
  form?: React.ReactElement | null;
  onConfirm?: (isPublish: boolean) => void;
  onCancel?: () => void;
  onOkHandle?: () => void;
}

const { Content } = Layout;

const ReportPage: React.FC<IReportPageProps> = (props) => {
  const {
    style,
    className,
    isEdit = false,
    isGuide = true,
    isShowReportForm = true,
    isSubmitting,
    submitType,
    title,
    topbar,
    form,
    onConfirm,
    onCancel,
    onOkHandle,
  } = props;

  const handleConfirm = useMemoizedFn((isPublish: boolean) => {
    onConfirm?.(isPublish);
  });

  const handleCancel = useMemoizedFn((e?: React.SyntheticEvent<Element>) => {
    e?.stopPropagation();
    history.goBack();
    onCancel?.();
  });

  return (
    <>
      <Content style={style} className={classnames('dbg-dbs-report-page', className)}>
        <Content.Header
          showBackButton
          title={title}
          onBackButtonClick={() => {
            history.goBack();
          }}
        />
        <Content.Body full>
          {React.isValidElement(topbar) && topbar}
          {isShowReportForm || (
            <div className="dbg-dps-report-nodata">
              <span>No date selected, please select the date on the left to proceed.</span>
            </div>
          )}
          {isShowReportForm && React.isValidElement(form) && form}
        </Content.Body>
        <Content.Footer>
          <ReportSubmitButton
            isEdit={isEdit}
            isDisabledSubmit={!isShowReportForm}
            isSubmitting={isSubmitting}
            submitType={submitType}
            onConfirm={handleConfirm}
          />
          <Button onClick={handleCancel}>Cancel</Button>
        </Content.Footer>
      </Content>
      {/* 离开页面的二次确认弹窗 */}
      <RoutePrompt
        when={isShowReportForm && isGuide}
        onOk={onOkHandle}
        message="Do you want to cancel?"
        description="The edited content cannot be restored after cancellation."
      />
    </>
  );
};

export default ReportPage;
